import { Injectable } from "@angular/core";
import * as firebase from 'firebase/app';
import { Observable, BehaviorSubject } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
// import { AngularFirestore } from 'angularfire2/firestore';

@Injectable()
export class AuthenticateService {

  constructor(private fireStore: AngularFirestore) {
    this._loggato.next(false);
  }
  user_logged = { uid: '', email: '', nome: '', cognome: '', amministratore: false, categoria:'' };
  _loggato = new BehaviorSubject<any>(false); //gdpr
  loggato$ = this._loggato.asObservable();

  registerUser(value) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().createUserWithEmailAndPassword(value.email, value.password)
        .then(
          res => {
            //console.log'registrato', res);
            this.get_info_user(res.user);
            // this.user_logged = { uid: res.user.uid, email: res.user.email };
            resolve(res)
          },
          err => reject(err))
    })
  }

  loginUser(value) {
    return new Promise<any>((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(value.email, value.password)
        .then(
          res => {
            //console.logres);

            // this.user_logged = { uid: res.user.uid, email: res.user.email };
            this.get_info_user(res.user).then((res) => {
              // this._loggato.next(true);
              if(res == 'esterno')
                this._loggato.next(-2);

              else if (this.user_logged.amministratore == true) {
                //console.log99);
                this._loggato.next(99);
              }
              else {
                console.log(this.user_logged);
                this._loggato.next(true);
              }

            })
            resolve(res)
          },
          err => reject(err))
    })
  }

  logoutUser() {
    return new Promise((resolve, reject) => {
      if (firebase.auth().currentUser) {
        firebase.auth().signOut()
          .then(() => {
            this.user_logged = { uid: '', email: '', nome: '', cognome: '', amministratore: false, categoria:'' };
            this._loggato.next(false);
            resolve();
          }).catch((error) => {
            //console.log'ERROR1');
            reject();
          });
      }
    })
  }

  get_info_user(user) {
    return new Promise((resolve, reject) => {
      //console.log'get_info_user');
      this.user_logged = { nome: '', cognome: '', email: user.email, uid: user.uid, amministratore: user.amministratore , categoria: ''};
      this.fireStore.collection<any>('userProfile', ref =>
        ref.where('uid', '==', user.uid)
      ).snapshotChanges().subscribe(actions => {
        actions.map(el => {
          let data = el.payload.doc.data();
          // if (data.nome == '' && data.cognome == ''){
          //   this.user_logged = { nome: undefined, cognome: undefined, email: user.email, uid: user.uid, amministratore: false };
          //   resolve('esterno');
          //   return data;
          // }
          // else {
            this.user_logged = { nome: data.nome, cognome: data.cognome, email: user.email, uid: user.uid, amministratore: data.amministratore, categoria: data.categoria };
            resolve('interno');
            return data; 
          // }
          
        })
        if(actions.length == 0){
          resolve('esterno');
        }
      })
      

    })
  }

  userDetails() {
    return firebase.auth().currentUser;
  }
  getstate_login() {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          // console.log(user);
          //console.loguser);
          this.get_info_user(user).then((res) => {
            console.log(this.user_logged);
            console.log(res);
            if (this.user_logged.amministratore == true) {

              this._loggato.next(99);
              resolve(99);
            }
            else if(res == 'esterno'){
              this._loggato.next(-2);
              resolve(-2);
            }
            else {
              this._loggato.next(true);
              resolve(true);
            }

          })
        }
        else {
          this._loggato.next(false);
          //console.log'MI SLOGGO');
          resolve(false);

        }
      })
    })

  }
  get_user_logged() {

  }

}
